export const USER_QUERY_KEYS = {} as const;
export const USER_MUTATION_KEYS = {
  signUp: ["sign-up"],
  verifyEmail: ["verify-email"],
  getVerificationEmail: ["get-verification-email"],
  updateUserDetails: ["update-user-details"],
} as const;
